

function TermAndCondition(props) {
  return 'TermAndCondition'
}
export default TermAndCondition;